import createLeadFieldSelect from "./createLeadFieldSelect";

export default createLeadFieldSelect("/leads/all_leads_office_zip_codes", {
  displayName: "LeadOfficeZipSelect",
  defaultPlaceholder: "Select Zip",
});
